import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { useMesVues, useStats, VuesOnglets, ProcessusPills } from "@/components/vues/commun";
import { PipelineThermo } from "@/components/vues/PipelineThermo";
import { CarteFleches } from "@/components/vues/CarteFleches";
import { Entonnoir } from "@/components/vues/Entonnoir";
import { Couloirs } from "@/components/vues/Couloirs";
import { Vide } from "@/components/commun";
import { HoteOutilParId } from "@/components/outils/HoteOutil";
import { useMessagerie } from "@/context/ThemeContext";
import { PipelineWa } from "@/components/messagerie/PipelineWa";
import FichesMaquette from "@/components/maquette/FichesMaquette";
import { useSearchParams } from "react-router-dom";

export default function Pipeline() {
  const [params] = useSearchParams();
  if (useMessagerie()) return <PipelineWa />;
  return params.get("vue") === "classique" ? <PipelineStandard /> : <FichesMaquette />;
}

function PipelineStandard() {
  const { user } = useAuth();
  const { vues, charge, vue, setVue } = useMesVues("pipeline");
  const [processus, setProcessus] = useState([]);
  const [pid, setPid] = useState(null);
  const [fiches, setFiches] = useState([]);
  const { stats, recharger } = useStats(vue === "carte_fleches" || vue === "entonnoir" ? pid : null);
  useEffect(() => { api.get("/processus").then((r) => { setProcessus(r.data); setPid(r.data[0]?.id); }); }, []);
  const charger = useCallback(() => { if (pid) api.get("/fiches", { params: { processus_id: pid } }).then((r) => setFiches(r.data)); }, [pid]);
  useEffect(() => { charger(); }, [charger]);
  const proc = processus.find((p) => p.id === pid);

  return (
    <div data-testid="page-pipeline" className="min-w-0">
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-4" data-testid="page-title">Pipeline</h1>
      <VuesOnglets vues={vues} vue={vue} setVue={setVue} testId="pipeline-view" />
      {vue && vue !== "couloirs" && <ProcessusPills processus={processus} pid={pid} setPid={setPid} />}
      {charge && !vue && <Vide texte="Aucune vue active pour cet écran." testId="pipeline-no-view" />}
      {vue === "pipeline_thermometre" && proc && <PipelineThermo proc={proc} fiches={fiches} role={user.role} onMaj={() => { charger(); recharger(); }} />}
      {vue === "carte_fleches" && <CarteFleches stats={stats} />}
      {vue === "entonnoir" && <Entonnoir stats={stats} />}
      {vue === "couloirs" && <Couloirs />}
      {vue?.startsWith("outil_") && pid && <HoteOutilParId id={vue.slice(6)} contexte={{ processus_id: pid }} hauteur={640} />}
    </div>
  );
}
